<template>
	<div class="box box-map">
		<div class="map" id="map"></div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import L from "leaflet";

export default {
	name: "box-map",
	data: function () {
		return {
			map_osm: false,
			markers_layer: false,
			user_map_action: true
		};
	},
	computed: {
		...mapGetters([ "search" ]),
	},
	watch: {
		"search.results": function () {
			this.$nextTick(function () {
				this.update_map();
			});
		},
	},
	methods: {
		update_map: function () {
			const self = this;
			
			if (this.markers_layer) {
				this.map_osm.removeLayer(this.markers_layer);
				this.markers_layer = L.layerGroup().addTo(this.map_osm);
			}
			if (self.search.results.length) {
				const lats = [];
				const lngs = [];
				for (const project of self.search.results) {
					// console.log("project.id", project.id);
					if (project.position.location && project.position.location.lat) {
						const icon = L.divIcon({
							className: "map-icon " + project.segment.code,
							html: "<div class=\"pin\"><div class=\"round\"></div></div>"
						});
						const marker = new L.marker(
							[project.position.location.lat, project.position.location.lon],
							{ icon: icon, title: project.nom, project: project }
						);
						marker.on("click", function () {
							self.$store.dispatch("toggle_active_project", {
								project: this.options.project
							});
						});
						marker.addTo(self.markers_layer);
						marker._icon.setAttribute("id", "pin-project-" + project.id);
						if (this.search.active_project && this.search.active_project.id == project.id) {
							marker._icon.classList.add("expanded");
						}
						lats.push(project.position.location.lat);
						lngs.push(project.position.location.lon);
					}
				}
				if (!this.search.filters.bounding_box) {
					const minlat = Math.min.apply(null, lats);
					const maxlat = Math.max.apply(null, lats);
					const minlng = Math.min.apply(null, lngs);
					const maxlng = Math.max.apply(null, lngs);
					const bbox = [[minlat,minlng],[maxlat,maxlng]];
					this.user_map_action = false;
					this.map_osm.fitBounds(bbox);
					this.user_map_action = true;
				}
			}
		},
		init_map: function () {
			const coords = [46.52863469527167, 2.43896484375];
			const GrayLight = L.tileLayer("http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
				attribution: "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
			});
			
			this.map_osm = L.map("map", {
				center: coords,
				zoom: 6,
				minZoom: 5,
				zoomControl: true,
				layers: [ GrayLight ]
			});
			
			this.map_osm.zoomControl.setPosition("topleft");

			this.markers_layer = L.layerGroup().addTo(this.map_osm);
			this.map_osm.on("zoomend", this.notif_map_changed);
			this.map_osm.on("dragend", this.notif_map_changed);
		},
		notif_map_changed: function () {
			if (this.user_map_action) {
				const bounding_box = {
					north: this.map_osm.getBounds().getNorth(),
					south: this.map_osm.getBounds().getSouth(),
					east: this.map_osm.getBounds().getEast(),
					west: this.map_osm.getBounds().getWest(),
				};
				this.$store.dispatch("set_filter", { bounding_box: bounding_box });
				this.$store.dispatch("search_projects");
			}
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			this.init_map();
			this.update_map();
		});
	}
};
</script>

<style lang="stylus">
@import '../../assets/css/app'
@import '../../assets/css/grid'
@import '../../assets/css/map'

</style>